// extracted by mini-css-extract-plugin
module.exports = {"container":"SssuUpdateModal_container__3b2_m","title":"SssuUpdateModal_title__306L3","warning":"SssuUpdateModal_warning__35vBx"};